import { FC } from 'react'

import DialogWindow from '@/components/DialogWindow'
import { Typography } from '@/components/ui'
import CustomInput from '@/components/ui/input/CustomInput'

import Cancel from '@/assets/icons/cancel-3.svg'
import Check from '@/assets/icons/check.svg'

interface ICreateHighlightFolderDialog {
	open: boolean
	name: string
	error: string
	onNameChange: (value: string) => void
	onClose: () => void
	onCreate: () => void
}

const CreateHighlightFolderDialog: FC<ICreateHighlightFolderDialog> = ({
	open,
	name,
	error,
	onNameChange,
	onClose,
	onCreate
}) => {
	return (
		<DialogWindow
			handleClick={onCreate}
			open={open}
			onClose={onClose}
			titleText='Create new folder'
			body={
				<div className='flex flex-col gap-2'>
					<Typography
						variant='text'
						className='!text-[16px] leading-[20px] text-black'
					>
						Folder name
					</Typography>
					<CustomInput
						value={name}
						onChange={e => onNameChange(e.target.value)}
						onKeyDown={e => {
							if (
								e.key === 'Enter' &&
								!e.nativeEvent.isComposing &&
								!e.repeat
							) {
								e.preventDefault()
								onCreate()
							}
						}}
						placeholder='Add name folder'
						maxLength={50}
						errorMessage={error}
					/>
				</div>
			}
			bodyClassname='flex flex-col gap-4'
			noButtonText={
				<>
					<Cancel className='w-3 h-3' />
					<span>Cancel</span>
				</>
			}
			yesButtonText={
				<>
					<Check />
					<span>Create folder</span>
				</>
			}
			noButtonClassname='!text-[16px] hover:bg-neutral-200'
			noButtonClassnameText='flex items-center gap-3'
			yesButtonClassname='bg-neutral-900 hover:bg-neutral-700'
			yesButtonClassnameText='flex items-center gap-3'
		/>
	)
}

export default CreateHighlightFolderDialog
